// Implements: F-UIX-010
/**
 * A search box (the mockup's `.search-input`): a magnifier inside a 32px field. The label is the
 * accessible name; the placeholder only hints at what can be typed. The value is the caller's, so
 * debouncing and the request it triggers stay in the container.
 */

import type { ReactElement } from "react";

import { Icon } from "../atoms/Icon";
import styles from "./SearchField.module.css";

export interface SearchFieldProps {
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder?: string | undefined;
}

export function SearchField({ label, value, onChange, placeholder }: SearchFieldProps): ReactElement {
  return (
    <div className={styles.search}>
      <span className={styles.icon}>
        <Icon name="search" size="sm" />
      </span>
      <input
        className={styles.input}
        type="search"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      />
    </div>
  );
}
